export const theme = {
  plain: {
    color: '#f5f5f5',
    backgroundColor: '#000F28',
  },
  styles: [
    {
      types: ['comment'],
      style: {
        color: 'rgb(105, 112, 152)',
        fontStyle: 'italic',
      },
    },
    {
      types: ['string', 'inserted', 'tag'],
      style: {
        color: 'rgb(212, 244, 144)',
      },
    },
    {
      types: ['number'],
      style: {
        color: 'rgb(247, 140, 108)',
      },
    },
    {
      types: ['builtin', 'char', 'constant', 'function'],
      style: {
        color: 'rgb(185, 239, 252)',
      },
    },
    {
      types: ['punctuation', 'selector'],
      style: {
        color: 'rgb(235, 210, 255)',
      },
    },
    {
      types: ['variable'],
      style: {
        color: 'rgb(255, 255, 255)',
      },
    },
    {
      types: ['class-name', 'attr-name'],
      style: {
        color: 'rgb(253, 179, 183)',
      },
    },
    {
      types: ['deleted'],
      style: {
        color: 'rgb(255, 85, 114)',
      },
    },
    {
      types: ['operator'],
      style: {
        color: 'rgb(137, 221, 255)',
      },
    },
    {
      types: ['boolean'],
      style: {
        color: 'rgb(255, 88, 116)',
      },
    },
    {
      types: ['keyword'],
      style: {
        fontStyle: 'italic',
      },
    },
    {
      types: ['doctype'],
      style: {
        color: 'rgb(235, 210, 255)',
        fontStyle: 'italic',
      },
    },
    {
      types: ['namespace'],
      style: {
        color: 'rgb(178, 204, 214)',
      },
    },
    {
      types: ['url'],
      style: {
        color: 'rgb(221, 221, 221)',
      },
    },
  ],
}
